import { Injectable } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class HumanizeMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams): string {
    const rawKey = params?.key ?? '';
    if (!rawKey) return '';

    const withSpaces = rawKey.replace(/[_-]+/g, ' ').trim();

    // Title case words, keep existing capitalization if key already has spaces
    const words = withSpaces.split(/\s+/);
    const humanized = words
      .map((w) => (w.length ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w))
      .join(' ');

    return humanized;
  }
}


